import { useTranslation } from "react-i18next";

export const useTipoServicio = () => {
    const { t } = useTranslation();
    const SELECT_TIPO_SERVICIO = [
        {
            value: '9a8ef9c5-7b02-11f0-a2c0-42010a8e000b',
            label: t('tipo_servicio_propio'),
        },
        {
            value: '9aaa07cd-7b02-11f0-a2c0-42010a8e000b',
            label: t('tipo_servicio_alquiler'),
        },
    ];
    return SELECT_TIPO_SERVICIO;
};